import { render, staticRenderFns } from "./WebhookTagSelector.vue?vue&type=template&id=a76caafe&lang=pug"
import script from "./WebhookTagSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./WebhookTagSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports